var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5153 7.7288L10.0153 0.652546C10.0116 0.649348 10.0082 0.645902 10.005 0.642234C9.72887 0.391109 9.36903 0.251953 8.99578 0.251953C8.62253 0.251953 8.2627 0.391109 7.98656 0.642234L7.97625 0.652546L0.484687 7.7288C0.331873 7.86932 0.209891 8.04003 0.126461 8.23013C0.0430305 8.42022 -3.15402e-05 8.62557 1.73323e-08 8.83317V17.5004C1.73323e-08 17.8982 0.158035 18.2797 0.43934 18.561C0.720644 18.8423 1.10218 19.0004 1.5 19.0004H6C6.39782 19.0004 6.77936 18.8423 7.06066 18.561C7.34196 18.2797 7.5 17.8982 7.5 17.5004V13.0004H10.5V17.5004C10.5 17.8982 10.658 18.2797 10.9393 18.561C11.2206 18.8423 11.6022 19.0004 12 19.0004H16.5C16.8978 19.0004 17.2794 18.8423 17.5607 18.561C17.842 18.2797 18 17.8982 18 17.5004V8.83317C18 8.62557 17.957 8.42022 17.8735 8.23013C17.7901 8.04003 17.6681 7.86932 17.5153 7.7288ZM16.5 17.5004H12V13.0004C12 12.6025 11.842 12.221 11.5607 11.9397C11.2794 11.6584 10.8978 11.5004 10.5 11.5004H7.5C7.10218 11.5004 6.72064 11.6584 6.43934 11.9397C6.15804 12.221 6 12.6025 6 13.0004V17.5004H1.5V8.83317L1.51031 8.8238L9 1.75036L16.4906 8.82192L16.5009 8.8313L16.5 17.5004Z",
    fill: "#19191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d1b5f349f53d01ad84268d1a3a60baa0.svg";
export { ForwardRef as ReactComponent };